import { StrictMode, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { BootstrapGate } from './components/BootstrapGate';
import { createAppTheme } from './theme/theme';
// Side-effect: initializes i18next with the bundled catalogs.
import './i18n/i18n';

function Root() {
  const theme = useMemo(() => createAppTheme(), []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BootstrapGate>
        <RouterProvider router={router} />
      </BootstrapGate>
    </ThemeProvider>
  );
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');
createRoot(rootEl).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
